<script setup>
import ModalError from '~/components/modals/ModalError.vue'

const store = useErrorModalStore()
const { t } = useI18n()
</script>

<template>
  <ModalError
    v-if="store.active"
    :title="store.active.title"
    :body="store.active.body"
    :close-label="t('errors.modal_close')"
    :on-close="store.close"
  />
</template>
